import { alertService } from "./alertservice";

const Services = {
  alertService,
};

export { Services, alertService };

export default Services;
